const CommonTitleComponent = () => import('@/views/kpi/CommonTitle/CommonTitleView')

export default [
    {
        path:'/CommonTitleIndex',
        name:'CommonTitleComponent',
        component:CommonTitleComponent
    }
]